import React, { useEffect, useState } from 'react';
import noImage from '../../assest/no-image.jpg';
import { useApi } from '@backstage/core-plugin-api';
import { promotionApiRef } from '../../apis/promotionApi';
import {
  NotificationApi,
  notificationApiRef,
} from '../../apis/notificationApi';

const PromotionImage = ({
  promotionId,
  assetURL,
  title,
  altText,
  className,
  style,
  callback = null,
  index = null,
}: any) => {
  const [imageSrc, setImageSrc] = useState<string>('');

  const promotionApi = useApi(promotionApiRef);
  const notificationApi: NotificationApi = useApi(notificationApiRef);

  useEffect(() => {
    if (!promotionId || !title || !assetURL) {
      setImageSrc('');
      return;
    }

    promotionApi
      .getPromotionImage(promotionId, title)
      .then((imageResponse: any) => {
        const contentType = imageResponse?.contentType || 'image/png';
        const base64Payload = imageResponse?.imageBase64;

        if (typeof base64Payload === 'string' && base64Payload.length > 0) {
          const src = base64Payload.startsWith('data:')
            ? base64Payload
            : `data:${contentType};base64,${base64Payload}`;
          setImageSrc(src);
        } else {
          setImageSrc('');
        }

        if (callback && index !== null) {
          callback(base64Payload, index);
        }
      })
      .catch((err: any) => {
        setImageSrc('');
        notificationApi.sendNotification({
          message: `Error occurred - ${err?.message}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      });
  }, [promotionId, title, assetURL]);

  return (
    <>
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={altText}
          className={className}
          style={style}
        />
      ) : (
        <img src={noImage} alt={altText} className={className} style={style} />
      )}
    </>
  );
};
export default PromotionImage;
